<script>
import { TweenMax, TimelineLite, Power2 } from "gsap";
import "SplitText";

export default {
  name: "split-text",

  props: {
    dur: { type: Number, default: 0.6 },
    stagger: { type: Number, default: 0.05 },
    lazy: { type: Boolean, default: false },
    stay: { type: Boolean, default: false }
  },

  data() {
    return {
      text: ""
    };
  },

  render() {
    return this.$scopedSlots.default({
      // not in use, but doesn't work without it..?
      text: this.text
    });
  },

  methods: {
    setup() {
      // eslint-disable-next-line
      this.headlineText = new SplitText(this.$el, {
        type: "lines",
        linesClass: "line line++"
      });
      // this.splitTextTimeline = new TimelineLite();

      this.headlineText.lines.forEach(line => this.wrap(line));

      // TweenMax.set(this.headlineText.lines, { y: 100 });
    },
    animate() {
      // this.splitTextTimeline.staggerTo(
      //   this.headlineText.lines,
      //   this.dur,
      //   {
      //     y: 0,
      //     immediateRender: true,
      //     force3D: true,
      //     transformOrigin: "top center -150",
      //     ease: Power2.easeOut
      //   },
      //   this.stagger,
      //   0,
      //   this.unWrap
      // );
      this.$el.style.opacity = "1";
      TweenMax.staggerFrom(
        this.headlineText.lines,
        this.dur,
        {
          y: "200%",
          ease: Power2.easeOut
        },
        this.stagger,
        this.splitRevert
      );
    },
    splitRevert() {
      this.headlineText.revert();
      // this.$el.innerHTML = this.text
    },
    wrap(el) {
      const div = document.createElement("div");
      div.classList.add("line-wrapper");
      el.parentNode.insertBefore(div, el);
      div.appendChild(el);
      return el;
    },
    observer(fn) {
      const cb = entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            fn();
          }
        });
      };
      const o = new IntersectionObserver(cb);
      o.observe(this.$el);
    }
  },

  mounted() {
    // CB to not wrap a fallbackfont before the expanded has loaded.
    // This was creating falsy line breaks.
    this.$nextTick(() => {
      if (this.lazy) {
        this.observer(this.animate);
      } else if (document.fonts) {
        document.fonts.ready.then(() => this.animate());
      } else {
        // for IE which doesn't supports
        setTimeout(this.animate.bind(this), 2000);
      }

      this.text = this.$el.innerHTML;
      this.setup();
    });
  }
};
</script>

<style>
.line-wrapper {
  overflow: hidden;
}
</style>